import { Chip } from "@mui/material";

export const MemberChip = () => {
    return (
        <Chip
            label="Member"
            color="secondary"
            size="small"
            sx={{ fontWeight: 'bold', backgroundColor: "#404041", color: "white" }}
        />
    );
};